<template>
  <div class="w-100">
    <div class="d-flex">
      <div class="col-4 d-flex align-items-baseline">
        <p class="col-4 ">Số thuê bao</p>
        <b-form-input class="col-8" v-model="soThueBaoTraCuu" @keypress.enter="searchPhoneInfo"></b-form-input>
      </div>
      <button class="btn btn-primary h-100" @click="searchPhoneInfo">Tra cứu</button>
    </div>
    <p class="mt-4 font-medium-3 font-weight-bold" style="padding-left: 1.8rem">Trạng thái thuê bao</p>
    <div class="d-flex  justify-content-around">
      <div class="row col-4 align-items-baseline">
        <p class="col-4 ">Số thuê bao</p>
        <b-form-input class="col-8" v-model="soThueBao" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
        <p class="col-4">Trạng thái hoạt động</p>
        <b-form-input class="col-8" v-model="trangThaiHoatDong" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
        <p class="col-4">Loại thuê bao</p>
        <b-form-input class="col-8" v-model="loaiThueBao" readonly></b-form-input>
      </div>
    </div>
    <div class="d-flex mt-2 justify-content-around">
      <div class="row col-4 align-items-baseline">
        <p class="col-4 ">Ngày can</p>
        <b-form-input class="col-8" v-model="ngayCan" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
        <p class="col-4">Số đang tại kho</p>
        <b-form-input class="col-8" v-model="soDangTaiKho" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
        <p class="col-4">Ngày dự kiến về kho (Chính chủ)</p>
        <b-form-input class="col-8" v-model="ngayDuKienVeKho" readonly></b-form-input>
      </div>
    </div>
    <div class="d-flex mt-2 justify-content-around">
      <div class="row col-4 align-items-baseline">
        <p class="col-4 ">Gói cam kết</p>
        <b-form-input class="col-8" v-model="commitType" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
        <p class="col-4">Tháng cam kết</p>
        <b-form-input class="col-8" v-model="months" readonly></b-form-input>
      </div>
      <div class="row col-4 align-items-baseline">
          <p class="col-4">Ngày dự kiến về kho (Không chính chủ)</p>
          <b-form-input class="col-8" v-model="ngayDuKienVeKhoKCC" readonly></b-form-input>
      </div>
    </div>
    <div class="row justify-content-center mt-4">
      <button class="btn btn-primary" @click="checkSubInfo">
        Tra cứu mua lại sim
      </button>
    </div>
    <b-modal
        id="modal-notification"
        title="Thông báo"
        ok-only
        ok-title="Đóng"
    >
      <div>
        <div v-html="msg"></div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import {BCol, BFormInput, BModal, BRow} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "MuaLaiSim",
  components: {
    BModal,  BCol, BRow,
    BFormInput
  },
  data() {
    return {
      soThueBaoTraCuu: '',
      soThueBao: '',
      trangThaiHoatDong: '',
      loaiThueBao: '',
      ngayCan: '',
      soDangTaiKho: '',
      ngayDuKienVeKho: '',
      ngayDuKienVeKhoKCC: '',
      msg:'',
      commitType:'',
      months:''
    }
  },
  methods: {
    validatePhoneNumber() {
      let msg = ""
      if (this.soThueBaoTraCuu.length === 0) {
        msg = "Số thuê bao không được để trống"
      }
      if (!this.soThueBaoTraCuu.startsWith("087") && !this.soThueBaoTraCuu.startsWith("8487") && !this.soThueBaoTraCuu.startsWith("87")) {
        msg = "Vui lòng nhập số thuê bao iTel"
      }
      if (this.soThueBaoTraCuu.startsWith("087") && this.soThueBaoTraCuu.length !== 10) {
        msg = "Số thuê bao không đúng định dạng"
      }
      if (this.soThueBaoTraCuu.startsWith("8487") && this.soThueBaoTraCuu.length !== 11) {
        msg = "Số thuê bao không đúng định dạng"
      }
      if (this.soThueBaoTraCuu.startsWith("87") && this.soThueBaoTraCuu.length !== 9) {
        msg = "Số thuê bao không đúng định dạng"
      }
      if (msg.length > 0) {
        this.$toast({
          component: ToastificationContent,
          props: {title: msg, icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return false
      }
      return true
    },
    formatPhoneForAPI() {
      if (this.soThueBaoTraCuu.startsWith("087")) {
        return this.soThueBaoTraCuu.replace("087", "8487")
      }
      if (this.soThueBaoTraCuu.startsWith("87")) {
        return this.soThueBaoTraCuu.replace("87", "8487")
      }
      return this.soThueBaoTraCuu
    },
    searchPhoneInfo() {
      if (this.validatePhoneNumber()) {
        this.loading(true)
        useJwt.get("b2c/getSubInfo/" + this.formatPhoneForAPI()).then(res=>{
          this.loading(false)
          console.log(res.data.result)
          const resData= res.data.result
          this.soThueBao = resData.msisdn
          this.trangThaiHoatDong= resData.statusStr
          this.loaiThueBao= resData.numType
          this.ngayCan= resData.canDate
          this.soDangTaiKho= resData.stockStr
          this.ngayDuKienVeKho= resData.vekhoDate
          this.ngayDuKienVeKhoKCC= resData.vekhoChinhChuDate
          this.commitType= resData.commitType
          this.months= resData.months
        }).catch((error) => {
          this.loading(false)
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.message?error.response.data.message:'Có lỗi xảy ra vui lòng thử lại', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        })
      }
    },
    checkSubInfo() {
      if (this.validatePhoneNumber()) {
        this.loading(true)
        useJwt.get("b2c/checkSubInfo/" + this.formatPhoneForAPI()).then(res=>{
          this.loading(false)
          this.msg=res.data.message
          this.$bvModal.show('modal-notification')
        }).catch((error) => {
          this.loading(false)
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.message?error.response.data.message:'Có lỗi xảy ra vui lòng thử lại', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        })
      }
    },
  }
}
</script>


<style scoped lang="scss">

</style>
